<template>
  <el-drawer :append-to-body="true" v-loading="loading" :wrapper-closable="false" :modal-append-to-body="false" size='740px' :close-on-click-modal="false" :visible.sync="drawer"
    :destroy-on-close="true" :with-header="false" :closeDrawer="drawer">
    <div class="creat-subscribe-box">
      <div class="title">{{editSubscribe == 'edit'?'编辑订阅':'创建新的订阅'}} <i class="close-icon el-icon-close" @click="closeDialog"></i></div>
      <div class="subscribe-process">
        <span :class="['step step1',stepStatu == 'a'?'curStep':'preStep']">
          <span class="num"><i class="label">1</i><i class="el-icon-check"></i></span>
          商机类型<i class="el-icon-arrow-right"></i>
        </span>
        <span :class="['step step2',stepStatu == 'a'?'':(stepStatu == 'b'?'curStep':'preStep')]">
          <i class="num"><i class="label">2</i><i class="el-icon-check"></i></i>
          偏好设置<i class="el-icon-arrow-right"></i>
        </span>
        <span :class="['step step3',stepStatu == 'a'?'':(stepStatu == 'b'?'':'curStep')]">
          <i class="num"><i class="label">3</i><i class="el-icon-check"></i></i>
          推送设置
        </span>
      </div>
      <!-- 商机类型 第一步 -->
      <div class="choice-step one-step" v-if="stepStatu == 'a'">
        <div class="name">
          <el-input :class="!pointerEvents?'editBox':''" ref="editN" :disabled="pointerEvents" v-model="subscriptionName" @keyup.enter.native="getCheckName" @blur="getCheckName"
            maxlength="30"></el-input>
          <i class="el-icon-edit" @click="editName"></i>
        </div>
        <div class="business-type choice-type">
          <div class="bsName">请选择商机类型</div>
          <div class="bsCard-box">
            <div class="card curDefalut">
              <img src="@/assets/subscribe/icon-01.png" class="calling-icon" alt="">
              <div class="info">
                <p class="txt1">企业商机</p>
                <p class="txt2">高阶拓客/商机订阅/订阅管理</p>
              </div>
            </div>
          </div>
        </div>
        <div class="subscribe-type choice-type clearfix">
          <div class="bsName">请选择订阅类型</div>
          <div class="bsCard-box">
            <div :class="['card',subscriptionType==1?'curCard':'']" @click="subscribeChoice(1,$event)">
              <div class="info" style="margin-bottom:14px">
                <span class="txt1">最近成立的企业</span>
                <span class="tag">实时</span>
              </div>
              <div class="info">
                <span class="txt2">最近3个月更新数据</span>
                <span class="num">{{updateDataNumES}}</span>
              </div>
              <i class="choice-mask"><img src="@/assets/subscribe/icon-choice.svg"></i>
            </div>
            <div :class="['card',subscriptionType==2?'curCard':'']" @click="subscribeChoice(2,$event)">
              <div class="info" style="margin-bottom:14px">
                <span class="txt1">最近有新网站的企业</span>
                <span class="tag">实时</span>
              </div>
              <div class="info">
                <span class="txt2">最近3个月更新数据</span>
                <span class="num">{{updateDataNumICP}}</span>
              </div>
              <i class="choice-mask"><img src="@/assets/subscribe/icon-choice.svg"></i>
            </div>
            <div :class="['card',subscriptionType==3?'curCard':'']">
              <div class="info" style="margin-bottom:14px">
                <span class="txt1">最近有中标的企业</span>
              </div>
              <div class="info">
                <span class="txt2">最近3个月更新数据</span>
                <span class="num">10万+</span>
              </div>
              <img src="@/assets/subscribe/expect.png" class="expect" alt="">
            </div>
            <div :class="['card',subscriptionType==4?'curCard':'']">
              <div class="info" style="margin-bottom:14px">
                <span class="txt1">有新建官网的企业</span>
              </div>
              <div class="info">
                <span class="txt2">最近3个月更新数据</span>
                <span class="num">10万+</span>
              </div>
              <img src="@/assets/subscribe/expect.png" class="expect" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 偏好 第二步 -->
      <div class="choice-step two-step" v-if="stepStatu == 'b'">
        <div class="custom-option">为<span class="twoTag">{{subscriptionType == 1?'最近成立的企业':'最近有新网站的企业'}}</span>配置自定义选项</div>
        <div class="select-box">
          <el-form label-width="48px">
            <el-form-item label="行业：">
              <!-- :value="value"  @input="treeDropdownInput"-->
              <TreeDropdown v-model="valueI" style="width:100%" :placeholder="placeholderIndustry" filterable multiple showCheckbox nodeKey="value" :data="optionsIndustry"
                :defaultProps="{ children: 'childOption'}" @change="changeIndustry" />

              <!-- <menu-common-sub ref='conditionVal' pageType="subscribe" :placeholder="placeholderIndustry" :defaultValue="valueI ? valueI :[]" :options='optionsIndustry' type="mapped" :error="error"
                @input-cv-focus='inputFocus' @validateNode="validateNode" @change='changeIndustry' /> -->
            </el-form-item>
            <el-form-item label="地区：">
              <TreeDropdown v-model="valueA" style="width:100%" :placeholder="placeholderArea" filterable multiple showCheckbox nodeKey="value" :data="optionsArea"
                :defaultProps="{ children: 'childOption'}" @change="changeArea" />

              <!-- <menu-common-sub ref='conditionVal' pageType="subscribe" :placeholder='placeholderArea' :defaultValue="valueA ? valueA :[]" :options='optionsArea' type="area" :error="error"
                @input-cv-focus='inputFocus' @validateNode="validateNode" @change='changeArea' /> -->
            </el-form-item>
          </el-form>
        </div>
        <div class="config-time-analysis">
          <img src="@/assets/subscribe/icon-info.svg">
          <div class="analysis-info">
            <p class="small-title">条件配置实时分析</p>
            <p class="des">根据您的偏好，近一周可获取{{realTimeNum}}条数据</p>
          </div>
        </div>
      </div>
      <!-- 推送设置 第三步-->
      <div class="choice-step two-step three-step" v-if="stepStatu == 'c'">
        <div class="custom-option">为<span class="twoTag">{{subscriptionType == 1?'最近成立的企业':'最近有新网站的企业'}}</span>配置自定义选项</div>
        <div class="select-box">
          <el-form :model="pushSet" ref="ruleForm" label-width="80px">
            <el-form-item label="推送周期：">
              <el-select v-model="pushSet.dateType" placeholder="请选择周期" style="maxwidth:300px" @change="changeDate()">
                <el-option label="每天" :value="1"></el-option>
                <el-option label="每周" :value="2"></el-option>
              </el-select>
              <el-select v-if="pushSet.dateType == '2'" v-model="pushSet.week" placeholder="请选择星期" style="maxwidth:300px">
                <el-option v-for="item in weekDays" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="具体时间：">
              <el-time-select :disabled="pushSet.dateType == 2" v-model="pushSet.hour" :editable="false" :clearable="false" :picker-options="{
                                          start: '00:00',
                                          step: '00:05',
                                          end: '23:59'
                                          }" placeholder="选择时间">
              </el-time-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="push-method">
          <div class="title0">推送方式</div>
          <div class="push-card">
            <div :class="['card',pushType == 1?'curPushCard':'']">
              <img src="@/assets/subscribe/icon-02.png">
              <div class="txt">
                <p class="txt01">浏览器推送</p>
                <p class="txt02">新商机将由小T推送</p>
              </div>
              <i class="choice-mask"><img src="@/assets/subscribe/icon-choice.svg"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="drawer_footer">
      <span class="yxBox" v-if="stepStatu != 'c'">已选择：<i class="cTag" v-if="subscriptionType">{{subscriptionType == 1?'最近成立的企业':(subscriptionType == 2?'最近有新网站的企业':'')}}</i></span>
      <el-button class="completeCreate" type="primary" v-if="stepStatu == 'c'" @click="completeCreate()">完成创建</el-button>
      <el-button size="small" type="plain" v-if="stepStatu != 'c'" @click="goStep(stepStatu,'next')">下一步</el-button>
      <el-button size="small" type="plain" v-if="stepStatu != 'a'" @click="goStep(stepStatu,'pre')">上一步</el-button>

    </div>
  </el-drawer>
</template>
<script>
import TreeDropdown from '@/components/treeDropdown/treeDropdown'
import MenuCommonSub from "@/views/clue/advancecomponets/children/MenuCommonSub.vue"
import { selectOptions } from '@/views/clue/api/newClueApi'
import { checkName, addSubscribe, subscribeList, subscribeDetail, editSubscribe } from '@/views/clue/api/subscribeApi'
import { parseTime } from "@/base/global";
import uniqueId from 'lodash/uniqueId'
export default {
  components: {
    MenuCommonSub,
    TreeDropdown
  },
  provide() {
    return {
      $_search: this // 搜索事件监听器
    }
  },
  data() {
    return {
      loading: false,
      drawerLoading: false,
      drawer: false,
      stepStatu: 'a',//创建步骤 a:第一步 b:第二步 c:第三步
      subscribeChoiceFlag: '',//订阅类型选择标签
      selectedContent: '',//选中的内容
      pointerEvents: true,//是否允许修改
      pushSet: {
        dateType: 1,//推送周期
        week: '',//星期几
        hour: '09:00',//推送小时
      },
      weekDays: [{
        label: '星期一',
        value: 1
      }, {
        label: '星期二',
        value: 2
      }, {
        label: '星期三',
        value: 3
      }, {
        label: '星期四',
        value: 4
      }, {
        label: '星期五',
        value: 5
      }, {
        label: '星期六',
        value: 6
      }, {
        label: '星期日',
        value: 7
      }],
      pushMethodChoiceFlag: '',//推送方式选择标签
      optionsIndustry: [],//所属行业
      optionsArea: [],//所属地区
      placeholderIndustry: '请选择关注行业，默认全选',
      placeholderArea: '请选择关注地区，默认全选',
      error: '',

      businessNum: '',//商机订阅数量
      businessType: 1,//商机类型
      pushType: 1,//推送方式
      subscriptionName: '',//订阅名称
      subscriptionType: '',//订阅类型
      industryIds: '',//行业id
      regionIds: '',//地区id

      updateDataNumES: '',//更新数据数量es
      updateDataNumICP: '',//更新数据数量icp
      realTimeNum: '',//实时数据

      id: '',//订阅id
      editSubscribe: 'add',//

      conditionType: '',
      inputOptions: [],
      inputValue: [],
      conditionName: [],
      relations: [],
      relationsVal: '',
      // options:{},
      valueI: [],//
      valueA: [],//
      conditionVos: [],
      relationType: 2, // 默认定义为1
      paramsObjI: {},//选中行业集合
      paramsObjA: {},//选中地区集合
      defaultNum: []//实时默认数值
    }
  },
  mounted() {
    if (this.$route.query.ld) {
      this.createdName(this.$route.query.type)
      this.openDrawer()
    }
    this.selectOptionsH('15')
    this.selectOptionsA('14')
  },
  methods: {
    closeDialog() {
      const confirmText = ['是否退出订阅编辑？', '点击确定按钮推出，该配置将不保存']
      const newDatas = []
      const h = this.$createElement
      for (const i in confirmText) {
        newDatas.push(h('p', null, confirmText[i]))
      }
      this.$confirm(
        '提示',
        {
          title: '提示',
          message: h('div', null, newDatas),
          showCancelButton: true,
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
          customClass: 'delsubscribe'
        }
      ).then(() => {
        this.drawer = false
        this.resetData()
        this.$router.push('/zxk/junbros/subscribeManagement')
      }).catch(action => {

      })
    },
    // 重置数据
    resetData() {
      this.id = ''
      this.stepStatu = 'a'
      this.pointerEvents = true
      this.subscriptionType = ''
      this.industryIds = ''
      this.regionIds = ''
      this.pushSet.dateType = 1
      this.pushSet.week = ''
      this.pushSet.hour = '09:00'
      this.paramsObjI = {}
      this.paramsObjA = {}
      this.valueI = []
      this.valueA = []
      this.realTimeNum = ''
    },
    openDrawer() {
      // this.resetData()
      this.drawer = true
      this.getDefaultNum()
    },
    handleClose(done) {
      console.log('done')
    },
    // 生成订阅名
    createdName(type) {
      this.editSubscribe = type
      this.subscriptionName = '未命名的订阅名称_' + parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')
    },
    // 编辑名字
    editName() {
      this.pointerEvents = false
      this.$nextTick(() => {
        this.$refs.editN.focus()
      })
    },
    // 名称是否重复
    getCheckName() {
      if (this.subscriptionName.trim() == '') {
        this.$message.error('订阅名不能为空')
        return false
      }
      checkName({ subscriptionName: this.subscriptionName }).then(res => {
        if (res.code == 200) {
          this.pointerEvents = true
        }
      }).catch(err => {

      })
    },
    subscribeChoice(val, e) {
      if (this.subscriptionType == val) {
        this.subscriptionType = ''
      } else {
        if (val == 1) {
          this.subscriptionType = val
        } else if (val == 2) {
          this.subscriptionType = val
        }
      }
    },
    goStep(step, val) {
      if (this.stepStatu == 'a') {
        if (this.subscriptionType == '') {
          this.$message.error('请选择订阅类型')
          return false
        }
      }
      if (val == 'next') {
        this.stepStatu = step == 'a' ? 'b' : 'c'
      } else {
        this.stepStatu = step == 'c' ? 'b' : 'a'
      }

      if (this.subscriptionType == 1) {
        this.realTimeNum = this.updateDataNumES
      } else {
        this.realTimeNum = this.updateDataNumICP
      }
    },
    // 推送方式选择
    pushMethodChoice(val) {
      if (this.pushType == val) {
        this.pushType = ''
      } else {
        this.pushType = val
      }
    },
    // 选择推送周期
    changeDate(e) {
      this.pushSet.hour = this.pushSet.dateType == 2 ? '08:00' : '09:00'
    },
    changeIndustry(value) {
      let industryValue = []
      value.forEach(v => {
        industryValue.push(v.value)
      });
      this.industryIds = industryValue.toString()
      this.subscribeList()
      this.valueI = value
      let params = {
        conditionId: 15,
        conditionType: 8,
        conditionValues: value,
        parentConditionId: null,
        screenType: 1,
        screenTypeText: "",
        values: [],
        myId: uniqueId([new Date().getTime()])
      }
      this.paramsObjI = params
    },
    changeArea(value) {
      let areaValue = []
      value.forEach(v => {
        areaValue.push(v.value)
      });
      this.regionIds = areaValue.toString()
      this.subscribeList()
      this.valueA = value

      let params = {
        conditionId: null,
        conditionType: 9,
        conditionValues: value,
        parentConditionId: null,
        screenType: 1,
        screenTypeText: "",
        values: [],
        myId: uniqueId([new Date().getTime()])
      }
      this.paramsObjA = params
    },
    // 第三步实时数据
    subscribeList() {
      // if(!this.industryIds && !this.regionIds){
      //       this.realTimeNum = ''
      //       return false
      // }
      let params = {
        timeType: 2,
        subscriptionType: this.subscriptionType,
        orderField: this.subscriptionType == 1 ? { "establishTime": "DESC" } : { "icpLastedTime": "DESC" },
        isUnLock: 0,
        industryIds: this.industryIds,
        regionIds: this.regionIds
      }

      // TODO 报错
      // {"timeType":2,"subscriptionType":1,"orderField":{"establishTime":"DESC"},"isUnLock":0,"industryIds":"","regionIds":"110105,110117"}

      subscribeList(params).then(res => {
        if (res.code == 200) {
          // this.realTimeNum = res.data.total > 200000 ? '200000+' : res.data.total
          this.realTimeNum = this._totalElements(res.data.total)
        }
      })
    },
    _totalElements(val) {
      if (val < 100) return val
      if (val < 200000) return `${val.toString().split('').reduce((res, v) => res ? res + 0 : v, '')}+`
      return '200000+'
    },

    // 失焦/聚焦/报错样式统一
    inputFocus(isFocus) {
      this.$emit("inputFocus", isFocus)
    },
    inputBlur(isBlur = false) {
      this.inputFocus(false)
    },
    validateNode() {
      this.$emit("validateNode")
    },
    async selectOptionsH(id, edit) {
      const { data } = await selectOptions({ id })
      this.optionsIndustry = data.optionVos || []
      // this.setData(data, edit)
    },
    async selectOptionsA(id, edit) {
      const { data } = await selectOptions({ id })
      this.optionsArea = data.optionVos || []
      // this.setData(data, edit)
    },
    // 行业、地区全选
    allSelectValue(allcondition, type) {
      let idsArr = []
      allcondition.forEach(item => {
        item.selected = true
        item.opened = true
        item.childOption && item.childOption.forEach(e => {
          e.selected = true
          e.childOption && e.childOption.forEach(ee => {
            ee.selected = true
          })
        })
        idsArr.push(item.value)
      })
      let params = {
        conditionId: null,
        parentConditionId: null,
        screenType: 1,
        screenTypeText: "",
        values: [],
        myId: uniqueId([new Date().getTime()])
      }
      if (type == 'area') {
        params.conditionType = 9
        params.conditionValues = allcondition
        this.allParamsObjA = params
        this.regionIds = idsArr.toString()
      } else {
        params.conditionType = 8
        params.conditionValues = allcondition
        this.allParamsObjI = params
        this.industryIds = idsArr.toString()
      }
    },
    // 完成创建
    completeCreate() {
      if (this.pushType == '') {
        this.$message.error('请选择推送方式')
        return false
      }
      // if(JSON.stringify(this.paramsObjI) == "{}"){
      //       this.allSelectValue(this.optionsIndustry,'industry')
      //       this.paramsObjI = this.allParamsObjI
      // }
      // if(JSON.stringify(this.paramsObjA) == "{}"){
      //       this.allSelectValue(this.optionsArea,'area')
      //       this.paramsObjA = this.allParamsObjA
      // }
      let conditionVos = []
      conditionVos.push(this.paramsObjI, this.paramsObjA)
      let paramsObj = {
        conditionVos: conditionVos,
        relationType: 2
      }
      let params = {
        id: this.id,
        subscriptionName: this.subscriptionName,
        subscriptionType: this.subscriptionType,
        industryIds: this.industryIds,
        regionIds: this.regionIds,
        businessType: 1,
        dateType: this.pushSet.dateType,
        // week:this.pushSet.dateType == 1?'':this.pushSet.week,
        hour: this.pushSet.hour,
        pushType: this.pushType,
        options: JSON.stringify(paramsObj)
      }
      if (this.pushSet.dateType == 2) {
        params.week = this.pushSet.week
      }
      this.loading = true
      console.log('paramsObj', paramsObj)
      if (this.editSubscribe == 'add') {
        addSubscribe(params).then(res => {
          if (res.code == 200) {
            this.loading = false
            this.drawer = false
            this.$parent.getSubscribeManagement()
            this.$router.push('/zxk/junbros/subscribeManagement')
            this.resetData()
          }
        }).catch(error => {
          this.loading = false
        })
      } else {
        editSubscribe(params).then(res => {
          if (res.code == 200) {
            this.loading = false
            this.drawer = false
            this.$parent.getSubscribeManagement()
            this.$router.push('/zxk/junbros/subscribeManagement')
            this.resetData()
          }
        }).catch(error => {
          this.loading = false
        })
      }

    },

    // 获取默认实时数值
    getDefaultNum() {
      let arr = [1, 2]
      let arrNum = []
      arr.forEach((v, index) => {
        let param = {
          timeType: 5,
          subscriptionType: v,
          orderField: v == 1 ? { "establishTime": "DESC" } : { "icpLastedTime": "DESC" },
          isUnLock: 0
        }
        subscribeList(param).then(res => {
          if (res.code == 200) {
            if (v == 1) {
              this.updateDataNumES = this._totalElements(res.data.total)
            } else if (v == 2) {
              this.updateDataNumICP = this._totalElements(res.data.total)
            }

          }
        }).catch(error => {
        })
      })
    },
    // 订阅详情
    getSubscribeDetail(id, step, type) {
      this.stepStatu = step
      this.id = id
      this.editSubscribe = type
      subscribeDetail({ id: id }).then(res => {
        if (res.code == 200) {
          this.subscriptionName = res.data.subscriptionName
          this.subscriptionType = res.data.subscriptionType
          this.industryNameList = res.data.industryNameList
          this.regionNameList = res.data.regionNameList
          this.industryIds = res.data.industryIds
          this.regionIds = res.data.regionIds
          this.pushSet.dateType = res.data.dateType
          this.pushSet.hour = res.data.hourTime
          this.pushSet.week = res.data.week
          this.pushType = res.data.pushType
          if (res.data.options) {
            this.valueI = JSON.parse(res.data.options).conditionVos[0] ? JSON.parse(res.data.options).conditionVos[0].conditionValues : []
            this.valueA = JSON.parse(res.data.options).conditionVos[1] ? JSON.parse(res.data.options).conditionVos[1].conditionValues : []
            this.changeIndustry(this.valueI)
            this.changeArea(this.valueA)
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.creat-subscribe-box {
  .title {
    height: 46px;
    line-height: 46px;
    font-weight: bold;
    color: #333333;
    font-size: 16px;
    padding-left: 24px;
    box-sizing: border-box;
    border-bottom: 1px solid #f1f1f2;
    position: relative;
    .close-icon {
      position: absolute;
      right: 24px;
      top: 0;
      bottom: 0;
      margin: auto;
      cursor: pointer;
      &::before {
        line-height: 45px;
      }
    }
  }
  .subscribe-process {
    border-bottom: 1px solid #f1f1f2;
    text-align: center;
    padding-top: 32px;
    padding-bottom: 32px;
    .step {
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      font-size: 16px;
      .num {
        width: 28px;
        height: 28px;
        background: #f2f3f5;
        border-radius: 14px;
        display: inline-block;
        margin-right: 12px;
        font-size: 16px;
        // font-family: Helvetica;
        color: #4e5969;
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }
      .el-icon-arrow-right {
        margin-left: 30px;
        margin-right: 28px;
      }
      .el-icon-check {
        display: none;
        &::before {
          content: url("~@/assets/subscribe/icon-step.svg");
        }
      }
      &.curStep {
        .num {
          background: #5088ff;
          color: #ffffff;
        }
      }
      &.preStep {
        .num {
          background: rgba(80, 136, 255, 0.1);
          color: #ffffff;
        }
        .el-icon-check {
          display: block;
          line-height: 28px;
          &:before {
            color: #5088ff;
          }
        }
        .label {
          display: none;
        }
      }
    }
  }
}
.choice-step {
  // padding: 32px 24px;
  padding: 32px 20px;
  box-sizing: border-box;
  height: calc(100vh - 205px);
  overflow-y: auto;
  .choice-type {
    margin-bottom: 40px;
    .bsName {
      font-weight: bold;
      color: #333333;
      line-height: 20px;
      font-size: 14px;
      position: relative;
      padding-left: 8px;
      box-sizing: border-box;
      margin-bottom: 16px;
      &::before {
        content: "";
        display: block;
        position: absolute;
        width: 4px;
        height: 14px;
        background: #5088ff;
        border-radius: 1px;
        left: 0;
        bottom: 0;
        top: 0;
        margin: auto;
      }
    }
  }
  .business-type {
    .bsCard-box {
      .card {
        position: relative;
        width: 307px;
        height: 78px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #e5e8ed;
        padding: 18px 16px;
        box-sizing: border-box;
        cursor: pointer;
        img {
          float: left;
          width: 42px;
          height: 42px;
          margin-right: 10px;
        }
        .info {
          .txt1 {
            font-weight: bold;
            color: #333333;
            line-height: 22px;
            font-size: 16px;
          }
          .txt2 {
            font-weight: 400;
            color: #999999;
            font-size: 12px;
          }
        }
        &.curDefalut {
          border: 1px solid #5088ff;
          box-shadow: 0px 6px 12px 0px rgba(80, 136, 255, 0.2);
        }
      }
    }
  }
  .subscribe-type {
    .bsCard-box {
      .card {
        position: relative;
        width: 220px;
        height: 95px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #e5e8ed;
        padding: 18px 0 18px 16px;
        box-sizing: border-box;
        float: left;
        // margin-right: 13px;
        margin-right: 11px;
        margin-bottom: 16px;
        cursor: pointer;
        .info {
          .txt1 {
            font-weight: bold;
            color: #333333;
            font-size: 16px;
            margin-right: 5px;
          }
          .tag {
            width: 33px;
            height: 18px;
            background: #5088ff;
            box-shadow: 0px 2px 4px 0px rgba(80, 136, 255, 0.1);
            border-radius: 2px;
            font-weight: 400;
            color: #ffffff;
            font-size: 12px;
            padding: 2px 5px;
            box-sizing: border-box;
          }
          .txt2 {
            font-weight: 400;
            color: #999999;
            font-size: 12px;
            margin-right: 22px;
          }
          .num {
            font-weight: 400;
            color: #ff0000;
            font-size: 12px;
          }
        }
        .choice-mask {
          position: absolute;
          right: 0;
          bottom: -1px;
          display: none;
          width: 29px;
          height: 23px;
          border-radius: unset;
        }
        &.curCard {
          background: #ffffff;
          box-shadow: 0px 6px 12px 0px rgba(80, 136, 255, 0.2);
          border-radius: 4px;
          border: 1px solid #5088ff;
          .choice-mask {
            display: block;
          }
        }
        .expect {
          width: 78px;
          height: 67px;
          position: absolute;
          right: 0;
          top: 0;
        }
        &:nth-of-type(3n) {
          margin-right: 0;
        }
      }
    }
  }
  &.two-step {
    .custom-option {
      font-weight: bold;
      color: #343951;
      line-height: 20px;
      font-size: 14px;
      margin-bottom: 40px;
      .twoTag {
        background: rgba(80, 136, 255, 0.15);
        border-radius: 2px;
        padding: 4px 4px;
        box-sizing: border-box;
        color: #5088ff;
        margin-left: 2px;
        margin-right: 4px;
      }
    }
    .select-box {
      margin-bottom: 20px;
    }
    .config-time-analysis {
      background: #f6fff6;
      border-radius: 4px;
      border: 1px solid #caefdc;
      padding: 16px 18px;
      box-sizing: border-box;
      img {
        width: 16px;
        height: 16px;
        float: left;
        margin-top: 2px;
      }
      .analysis-info {
        padding-left: 26px;
        box-sizing: border-box;
        .small-title {
          font-weight: bold;
          color: #30bf78;
          font-size: 15px;
          line-height: 20px;
        }
        .des {
          font-weight: 400;
          color: #999999;
          line-height: 20px;
          font-size: 12px;
        }
      }
    }
  }
  &.three-step {
    .push-method {
      .title0 {
        font-weight: bold;
        color: #333333;
        line-height: 20px;
        font-size: 14px;
        position: relative;
        padding-left: 8px;
        box-sizing: border-box;
        margin-bottom: 16px;
        &::after {
          display: block;
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 4px;
          height: 14px;
          background: #5088ff;
          border-radius: 1px;
        }
      }
      .push-card {
        .card {
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #e5e8ed;
          padding: 18px 16px;
          box-sizing: border-box;
          width: 307px;
          position: relative;
          cursor: pointer;
          img {
            width: 42px;
            height: 42px;
            border-radius: 4px;
            float: left;
          }
          .txt {
            padding-left: 52px;
            box-sizing: border-box;
            .txt01 {
              font-weight: bold;
              color: #333333;
              line-height: 22px;
              font-size: 16px;
            }
            .txt02 {
              font-weight: 400;
              color: #999999;
              font-size: 12px;
            }
          }

          .choice-mask {
            position: absolute;
            right: 0;
            bottom: -1px;
            display: none;
            img {
              width: 29px;
              height: 23px;
              border-radius: unset;
            }
          }
          &.curPushCard {
            border: 1px solid #5088ff;
            .choice-mask {
              display: block;
            }
          }
        }
      }
    }
    .select-box {
      .el-select {
        margin-right: 10px;
        width: 220px;
      }
    }
  }
}
.drawer_footer {
  bottom: 0;
  position: absolute;
  width: 100%;
  border-top: 1px solid #f1f1f2;
  // height: 65px;
  padding: 14px 24px;
  box-sizing: border-box;
  background: #ffffff;
  z-index: 9;
  .el-button {
    float: right;
    width: 100px;
    height: 36px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    border: 1px solid #5088ff;
    font-weight: 400;
    color: #5088ff;
    font-size: 14px;
    margin-left: 30px;
  }
  .yxBox {
    display: inline-block;
    line-height: 36px;
    .cTag {
      border-radius: 2px;
      background: rgba(80, 136, 255, 0.15);
      font-weight: bold;
      color: #5088ff;
      font-size: 14px;
      padding: 4px 4px;
      box-sizing: border-box;
      margin-left: 3px;
    }
  }
  .completeCreate {
    width: 100px;
    height: 36px;
    background: #5088ff;
    border-radius: 4px;
    font-weight: 400;
    color: #ffffff;
    font-size: 14px;
  }
}
::v-deep {
  .choice-step {
    .name {
      margin-bottom: 40px;
      display: flex;
      .el-input {
        max-width: 308px;
        //    border: 1px solid rgba(51, 51, 51, 0.5);
        .el-input__inner {
          border: none;
          color: #5088ff;
          font-weight: 500;
          color: #5088ff;
          line-height: 20px;
          font-size: 14px;
          &:focus {
            box-shadow: none;
          }
        }

        &.is-disabled {
          //    border: none;
        }
        &.editBox {
          .el-input__inner {
            border: 1px solid #e8e8f0;
          }
        }
      }
      .el-icon-edit {
        margin-left: 6px;
        cursor: pointer;
        &::before {
          content: url("~@/assets/subscribe/edit.svg");
          font-size: 34px;
        }
      }
    }
    &.two-step {
      .el-form-item__label {
        text-align: left;
        padding-right: 0;
        font-weight: bold;
      }
    }
  }
  .choice-step {
    .tagInput {
      width: 100%;
    }
    .el-form-item__content {
      line-height: 17px;
    }
  }
}
</style>
<style lang="scss">
.el-drawer__open .el-drawer.rtl {
  background: #ffffff;
}
.el-drawer__body {
  padding: 0;
}
</style>